export class UrlService {

  // Константи для роботи з DigitalOcean (можна винести в EnvironmentService, але поки хай будуть тут для наочності)
  private static readonly DO_SPACE_DOMAIN = 'digitaloceanspaces.com';
  private static readonly CDN_INSERTION = 'cdn.';

  /**
   * Метод для отримання поточного URL із window
   * @returns Поточний URL як рядок
   */
  static getCurrentUrl(): string {
    try {
      return window.location.href;
    } catch (error) {
      console.error("Unable to access current URL:", error);
      throw new Error("Failed to retrieve current URL.");
    }
  }

  /**
   * Метод для отримання сегментів шляху з URL
   * @param url - Вхідний URL
   * @returns Масив сегментів шляху
   */
  static getPathSegments(url: string): string[] {
    return new URL(url).pathname.split("/").filter(Boolean);
  }

  /**
   * Метод для отримання projectID із поточного URL
   * @returns projectID як число або null
   */
  static getProjectIDFromUrl(): number | null {
    try {
      const url = this.getCurrentUrl();
      const pathSegments = this.getPathSegments(url);
      const projectID = pathSegments.find((segment) => !isNaN(Number(segment)));
      console.log(`Project ID, successfully received: ${projectID}`);
      return projectID ? parseInt(projectID, 10) : null;
    } catch (error) {
      console.error("Error extracting projectID from URL:", error);
      return null;
    }
  }





  // =========================================================
  // CDN LOGIC (Новий функціонал)
  // =========================================================

  /**
   * Базовий приватний метод для конвертації URL
   * Використовує URL API для безпечної заміни хоста
   */
  private static transformToCdn(originalUrl: string): string {
    if (!originalUrl || typeof originalUrl !== 'string') return originalUrl;

    try {
      const urlObj = new URL(originalUrl);
      const host = urlObj.hostname;

      // Перевіряємо, чи це DigitalOcean і чи ще немає CDN у назві
      if (host.includes(this.DO_SPACE_DOMAIN) && !host.includes(this.CDN_INSERTION)) {
        // Вставка '.cdn.' перед '.digitaloceanspaces.com'
        // було: bucket.fra1.digitaloceanspaces.com
        // стало: bucket.fra1.cdn.digitaloceanspaces.com
        urlObj.hostname = host.replace(
          this.DO_SPACE_DOMAIN,
          `${this.CDN_INSERTION}digitaloceanspaces.com` // .cdn.digitaloceanspaces.com
        );
        return urlObj.toString();
      }
    } catch (e) {
      // Якщо прийшов невалідний URL (наприклад, відносний шлях), повертаємо як є
      return originalUrl;
    }

    return originalUrl;
  }

  /**
   * Публічний метод для GLB файлів
   * Додатково перевіряє наявність специфічної папки або розширення
   */
  static getImageServerCdnUrl(url: string): string {
    // Валідація: конвертуємо тільки якщо це схоже на шлях до 3D моделі
    // Можна перевіряти папку '/glb/' або розширення '.glb'
    if (url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png') || url.endsWith('.webp')) {
      return this.transformToCdn(url);
    }
    return url;
  }
  /**
   * Публічний метод для GLB файлів
   * Додатково перевіряє наявність специфічної папки або розширення
   */
  static getGlbCdnUrl(url: string): string {
    // Валідація: конвертуємо тільки якщо це схоже на шлях до 3D моделі
    // Можна перевіряти папку '/glb/' або розширення '.glb'
    if (url.includes('/glb/') || url.endsWith('.glb')) {
      return this.transformToCdn(url);
    }
    return url;
  }

  /**
   * Публічний метод для Зображень
   * (Заготовка на майбутнє)
   */
  static getImageCdnUrl(url: string): string {
    // Тут можна додати фільтр по розширеннях (jpg, png, webp)
    return this.transformToCdn(url);
  }

  /**
   * Публічний метод для будь-яких інших статичних асетів (шаблони тощо)
   */
  static getAssetCdnUrl(url: string): string {
    return this.transformToCdn(url);
  }

  /**
   * Метод для масової конвертації URL у конфігурації продукту.
   * Модифікує переданий об'єкт "на льоту" (in-place).
   * * @param config - Об'єкт конфігурації (містить масив products)
   * @returns Модифікований об'єкт конфігурації
   */
  static processConfigurationUrls(config: any): any {
    debugger
    // 1. Перевірка на валідність структури
    if (!config || !config.products || !Array.isArray(config.products)) {
      console.warn('UrlService: Config does not contain valid products array');
      return config;
    }

    // 2. Ітерація по продуктах
    config.products.forEach((product: any) => {
      // Обробка основного GLB файлу
      if (product.glbBundle && typeof product.glbBundle === 'string') {
        product.glbBundle = this.getGlbCdnUrl(product.glbBundle);
      }

      // Обробка додаткових ресурсів (якщо вони з'являться в майбутньому)
      if (product.resourceUrl && typeof product.resourceUrl === 'string') {
        product.resourceUrl = this.getAssetCdnUrl(product.resourceUrl);
      }
    });

    return config;
  }
}
